module.exports = __webpack_public_path__ + "static/media/wtb1.2508b15f.jpg";